import React, { createContext, useContext, useEffect, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("ro_theme") || "dark");
  const [density, setDensity] = useState(() => localStorage.getItem("ro_density") || "standard");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("ro_theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("ro_density", density);
  }, [density]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const toggleDensity = () => setDensity((d) => (d === "standard" ? "compact" : "standard"));
  const compact = density === "compact";

  return (
    <UIContext.Provider value={{ theme, density, compact, toggleTheme, toggleDensity }}>
      {children}
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
